import successIcon from "assets/img/icons/success-green-big.svg";
import { useSoundPath } from "hooks/useSoundPath";
import { useNavigate } from "react-router-dom";

const QuickCraftSuccess = ({ closeWindow }) => {

  const navigate = useNavigate();
  const playSound = useSoundPath();

  return (
    <>
      <header className="modal-window__header">
        <img src={successIcon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Success!</h5>
        <p className="modal-window__info">Identity was crafted</p>
      </header>
      <footer className="modal-window__footer modal-window__footer--success">
        <button
          className="modal-window__footer-close"
          onClick={() => {
            navigate("/inventory/identities/");
            playSound("main");
          }}
        >
          View Identity
        </button>
        <button className="modal-window__footer-submit" onClick={closeWindow}>
          Done
        </button>
      </footer>
    </>
  );
};

export default QuickCraftSuccess;
